import { Component, Input } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'

import { MachineStateComputed } from '../../../../models/states-computed.models'
import {
  AlgorithmMode,
  LoadStatus,
  State,
} from '../../../../models/states.models'
import { TouaregControlLayoutMessage } from '../../layout/touareg-control-state-layout.component'
import { TouaregControlMessageDialogComponent } from '../touareg-control-message-dialog/touareg-control-message-dialog.component'
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-state-info',
  templateUrl: './touareg-control-state-info.component.html',
  styleUrls: ['./touareg-control-state-info.component.scss'],
  imports: [Samv2Module],
})
export class TouaregControlStateInfoComponent {
  @Input()
  message!: TouaregControlLayoutMessage

  @Input()
  set state(currentState: MachineStateComputed) {
    this._currentState = currentState
    this._storeData(currentState)
  }

  get state(): MachineStateComputed {
    return this._currentState
  }

  private _currentState!: MachineStateComputed

  public pickNumber: number | null = null
  public displayState!: 'none' | 'novalues' | 'loading' | 'pickNumber'
  public animType: 'none' | 'forward' | 'backward' | null = null
  public stateLabel: string | null = null

  constructor(
    private _dialog: MatDialog,
    private _dialogRef: MatDialogRef<TouaregControlMessageDialogComponent>,
    private translate: TranslateService
  ) {}

  private _storeData(state: MachineStateComputed) {
    switch (state?.state) {
      case State.IDLE:
        this.pickNumber = null
        this.animType = null
        this.displayState = 'none'
        this.stateLabel = this.translate.instant('touareg.ready')
        break

      case State.PICKING_SCANNING:
        this.pickNumber = this._getPickNumber(state)
        this.animType = 'forward'
        this.displayState = 'loading'
        this.stateLabel = this.translate.instant('touareg.scanning')
        break

      case State.PICKED:
        if (state.algorithm_mode === AlgorithmMode.auto) {
          this.pickNumber = this._getPickNumber(state)
          this.animType = null
          this.displayState = 'pickNumber'
          this.stateLabel = this.translate.instant('touareg.loaded')
        } else {
          this.pickNumber = this._getPickNumber(state)
          this.displayState = 'pickNumber'
          this.stateLabel = this.translate.instant('touareg.loaded')
        }
        break

      case State.DROP_SCANNING:
        this.pickNumber = this._getPickNumber(state)
        this.animType = 'backward'
        this.displayState = 'loading'

        this.stateLabel = this.translate.instant('touareg.unloading')

        break

      case State.DROP_ACCEPTING_USER_CHOICE:
      case State.DROP_BLOCKED_BY_USER:
        this.pickNumber = this._getPickNumber(state)
        this.animType = null
        this.stateLabel = this.translate.instant('touareg.unloaded')
        this.displayState = 'pickNumber'
        break

      default:
        this.pickNumber = null
        this.animType = null
        this.stateLabel = null
        this.displayState = 'none'
    }
  }

  private _getPickNumber(state: MachineStateComputed): number | null {
    let count = null
    if (state?.tags_list) {
      count = state.tags_list.filter(
        (t) => t.load_status === LoadStatus.loaded
      ).length
    }
    return count
  }

  public onOpenMessage() {
    if (!this.message) return

    this._dialogRef = this._dialog.open(TouaregControlMessageDialogComponent, {
      data: { message: this.message },
    })
  }
}
